import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Box, Button } from '@mui/material'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import { getStatusOption } from './Constant'
import CopanySettingTable from './CopanySettingTable'
import * as mdt from '../../../common/modaltypes'
import ComapanyLuggageSettingModel from './ComapanyLuggageSettingModel'
import { connect } from 'react-redux'
import { updateModal } from '../../../../store/common/common_action'
import { fetchCompaniesListAllAtoms, fetchUserListForLuggageSettingUpdateAtom, getCompaniesListAllForMTPLMasterData } from '../../../common/jotaiState/mtplMaster'
import { useAtom } from 'jotai'
import { useTranslation } from '../../../../i18n/I18nProvider'
const CompanyLuggageSetting = (props) => {
  const { translations } = useTranslation()
  const mtpl = translations?.mtplMaster || {}
  const statusOpt = getStatusOption(mtpl)
  const { data: { common }, updateModal } = props
  const { loginData, showModal, modalType } = common
  const { intCompanyID } = loginData
  const [selStatus, setSelStatus] = useState(statusOpt[1])
  const [showTable, setShowTable] = useState(false)
  const [selEditLuggageSetting, setSelEditLuggageSetting] = useState('')
  const [, getCompanyListAll] = useAtom(fetchCompaniesListAllAtoms)
  const [companiesListAllForMTPLMasterData] = useAtom(getCompaniesListAllForMTPLMasterData)
  const [, getUserList] = useAtom(fetchUserListForLuggageSettingUpdateAtom)
  useEffect(() => {
    getUserList()
  }, [])
  useEffect(() => {
    if (translations && selStatus?.id !== undefined) {
      const updatedOpt = statusOpt.find((opt) => opt.id === selStatus.id)
      if (updatedOpt) setSelStatus(updatedOpt)
    }
  }, [translations])
  const editLuggageSetting = () => {
    let dataForModel = {
      headText: mtpl.editCompanyLuggageSetting || 'Edit Company Luggage Setting',
      // BranchId: selEditBranch,
      isEdit: true,
      // BranchList: BranchDetailsList,
      // stateList: stateOptList,
      // cityList: cityOptList,
      // loginData: loginData,
      // dropDownData: ModalHeaderDropDownData
    }
    return <ComapanyLuggageSettingModel  dataForModel={dataForModel} updateModal={updateModal} selEditLuggageSetting={selEditLuggageSetting} />
  }
  const getLoadData = () => {
    setShowTable(true)
    const obj = {
      intCompanyID: -1,
      intCityID: 0,
      intStateID: 0,
      intIsActive: selStatus.id
    }
    getCompanyListAll(obj)

  }
  return (
    <>
      <Box sx={{ ...sx.reportFlex, marginTop: '10px' }} className='reportButton'>
        <Item sx={sx.itemsx}>
          <DropDownOA
            label={mtpl.status || 'Status'}
            id={'status'}
            data={statusOpt || []}
            defaultvalue={selStatus?.name || selStatus}
            value={selStatus?.name || selStatus}
            onSelect={(val) => {
              setSelStatus(val)
            }}
            noCross={true}
            idKey={`id`}
            dataKey={`name`}
            minWidth="250px"
            nextId={'loadBtn'}
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" id={'loadBtn'} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
            // onKeyDown={(e) => {
            //   navigation3(e, 'createBtn', 'status', () => { })
            // }}
            onClick={getLoadData}
          >
            {mtpl.load || 'LOAD'}
          </Button>
        </Item>
      </Box>
      {showTable &&
        <Box sx={sx.reportFlex}>
          <CopanySettingTable
            setSelEditLuggageSetting={setSelEditLuggageSetting}
            updateModal={updateModal}
            companiesListAllForMTPLMasterData={companiesListAllForMTPLMasterData}
          />
        </Box>
      }
      {showModal && mdt.companyLuggageSettingModel === modalType ? editLuggageSetting() : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(CompanyLuggageSetting)
